import { useEffect, useState } from 'react';

import { useChain } from 'context/chain/context';
import SettingModal from './SettingModal';

type Props = {
  image: string | null;
  tokenId: string;
};

const SettingIcon = () => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.50144 16.492H6.49991C6.31184 16.492 6.12942 16.4277 5.98289 16.3098C5.83635 16.192 5.73452 16.0275 5.69428 15.8438L5.35866 14.2903C4.91096 14.0941 4.48643 13.8488 4.09291 13.5589L2.57812 14.0412C2.39882 14.0984 2.20536 14.0926 2.02986 14.0246C1.85436 13.9567 1.70739 13.8307 1.61334 13.6677L0.109277 11.0694C0.0162169 10.9062 -0.0187154 10.7163 0.0101948 10.5307C0.0391051 10.3451 0.130146 10.1748 0.268424 10.0477L1.44348 8.97574C1.39004 8.49015 1.39004 8.00015 1.44348 7.51456L0.268424 6.44505C0.12995 6.31788 0.0387855 6.14744 0.00987046 5.96166C-0.0190445 5.77589 0.0160057 5.5858 0.109277 5.42255L1.61004 2.8226C1.70409 2.65959 1.85107 2.53365 2.02657 2.4657C2.20206 2.39775 2.39553 2.39188 2.57482 2.44905L4.08961 2.93144C4.29081 2.78302 4.50026 2.64448 4.7163 2.51915C4.92493 2.40205 5.13932 2.29568 5.35866 2.20085L5.6951 0.648958C5.73515 0.465236 5.83679 0.300721 5.98317 0.182689C6.12955 0.0646566 6.31187 0.000197875 6.49991 0H9.50144C9.68948 0.000197875 9.8718 0.0646566 10.0182 0.182689C10.1646 0.300721 10.2662 0.465236 10.3063 0.648958L10.646 2.20168C10.8769 2.30393 11.1028 2.41854 11.3213 2.54636C11.525 2.66427 11.7221 2.79374 11.9117 2.93309L13.4274 2.4507C13.6065 2.39374 13.7998 2.39972 13.9751 2.46766C14.1505 2.5356 14.2973 2.66141 14.3913 2.82425L15.8921 5.4242C16.0834 5.75981 16.0174 6.18448 15.7329 6.44588L14.5579 7.51786C14.6113 8.00345 14.6113 8.49345 14.5579 8.97904L15.7329 10.051C16.0174 10.3132 16.0834 10.7371 15.8921 11.0727L14.3913 13.6727C14.2973 13.8357 14.1503 13.9616 13.9748 14.0295C13.7993 14.0975 13.6058 14.1034 13.4265 14.0462L11.9117 13.5638C11.5185 13.8535 11.0943 14.0986 10.6468 14.2944L10.3063 15.8438C10.266 16.0274 10.1643 16.1917 10.018 16.3096C9.8716 16.4275 9.68937 16.4918 9.50144 16.492ZM7.99738 4.94759C7.12259 4.94759 6.28363 5.29509 5.66506 5.91366C5.04649 6.53223 4.69899 7.37119 4.69899 8.24598C4.69899 9.12076 5.04649 9.95972 5.66506 10.5783C6.28363 11.1969 7.12259 11.5444 7.99738 11.5444C8.87216 11.5444 9.71112 11.1969 10.3297 10.5783C10.9483 9.95972 11.2958 9.12076 11.2958 8.24598C11.2958 7.37119 10.9483 6.53223 10.3297 5.91366C9.71112 5.29509 8.87216 4.94759 7.99738 4.94759Z'
        fill='white'
      />
    </svg>
  );
};

const Card: React.FC<Props> = ({ image, tokenId }) => {
  const [open, setOpen] = useState(false);
  const [bonuspackData, setBonuspackData] = useState(null);

  const {
    bonuspacks: { all: allBonuspacks },
  } = useChain();

  useEffect(() => {
    if (allBonuspacks.length) {
      const bonuspackData = allBonuspacks.find(
        bonuspack => bonuspack.tokenId === tokenId
      );
      setBonuspackData(bonuspackData);
    }
  }, [allBonuspacks, tokenId]);

  return (
    <div className='landcard border rounded-xl flex flex-col w-full h-full'>
      <div className='thumbnail'>
        {image && (
          <div className='image' style={{ backgroundImage: `url(${image})` }} />
        )}
      </div>
      <div className='detail flex justify-between items-center bg-dark'>
        <span className='text-white text-sm font-play break-all'>
          {bonuspackData
            ? `${bonuspackData.type}_${bonuspackData.tokenId}`
            : tokenId}
        </span>
        <span className='cursor-pointer' onClick={() => setOpen(true)}>
          <SettingIcon />
        </span>
      </div>
      <SettingModal
        isOpen={open}
        onClose={() => setOpen(false)}
        image={image}
        tokenId={tokenId}
        bonuspackData={bonuspackData}
      />
    </div>
  );
};

export default Card;
